import { useWeb3React } from "@web3-react/core"
import React, { useContext } from "react"
import PoolStakePage from "src/components/PoolStakePage"
import { POOLS_MAP, PoolName, ChainId } from "src/constants"
import { BIG_ZERO } from "src/constants/bigNumber"
import { useClaimReward } from "src/hooks/useClaimReward"
import usePoolData from "src/hooks/usePoolData"
import { useRewardsHelpers } from "src/hooks/useRewardsHelpers"
import { RewardsBalancesContext } from "src/providers/RewardsBalancesProvider"
import { useGetBoostByPid } from "src/hooks/BoostFarming/useFarmBoostContract"
import useFarmBoostHandler from "src/hooks/BoostFarming/useFarmBoostHandler"
import {
  usePollFerroBoostPoolData,
  usePollUserFerroBar,
  usePollUserFerroBoost,
} from "src/state/xFer/hooks"

interface Props {
  poolName: PoolName
}

const Stake = ({ poolName }: Props) => {
  const { account, chainId } = useWeb3React()
  const [, userShareData, boostData] = usePoolData(poolName)
  const { approveAndStake, unstake, amountStaked, isPoolIncentivized } =
    useRewardsHelpers(poolName)
  const [rewardBalances, rewardTokens] = useContext(RewardsBalancesContext)
  const { claim } = useClaimReward(
    rewardBalances[poolName] || BIG_ZERO,
    poolName,
    rewardTokens[poolName],
  )
  const pool = POOLS_MAP[poolName]
  const { data: boostedRewards } = useGetBoostByPid(
    pool?.rewardPids[chainId as ChainId],
  )
  const { onHarvestBoost } = useFarmBoostHandler()

  usePollUserFerroBar(account)
  usePollUserFerroBoost(account)
  usePollFerroBoostPoolData()

  if (isPoolIncentivized) {
    return (
      <PoolStakePage
        approveAndStake={approveAndStake}
        lpWalletBalance={userShareData?.lpTokenBalance || BIG_ZERO}
        unstake={unstake}
        amountStaked={amountStaked}
        rewardBalance={rewardBalances[poolName] || BIG_ZERO}
        boostedRewards={boostedRewards || BIG_ZERO}
        rewardTokens={rewardTokens[poolName]}
        harvest={claim}
        harvestBoost={() =>
          onHarvestBoost(pool?.rewardPids[chainId as ChainId], boostedRewards)
        }
        isBoosted={!!boostData?.isBoosted}
        token={pool.lpToken}
        poolName={poolName}
      />
    )
  }
  return null
}

export default Stake
